
 

export const convertSlotsToEvents = (slots, preferredDates = [],role_slug) => {

const formattedPreferredDates =  preferredDates?.map(date => {
    const [dd, mm, yyyy] = date.split("/");
    return `${yyyy}-${mm}-${dd}`;
  });
 let filteredSlots = slots;
if (role_slug == 'superadmin' || role_slug=='manufacture-lead') {
  filteredSlots = slots; 
   } else {
     filteredSlots = slots?.filter(slot => {
      const isBookedOrRequest = slot?.status === 'Booked' || slot?.status === 'Request';
      const hasNoPatientName = !slot?.patient_name;
      const isInvalidBooked = isBookedOrRequest && hasNoPatientName;
      
      
      return !isInvalidBooked; 
    });
  }
    return filteredSlots?.map(slot => {
        const startTime = "T10:00:00";
        const endTime = "T12:00:00";
        // slot.date may be a full ISO datetime (e.g. "2026-01-01T05:30:00")
        // or a plain date string ("2026-01-01"). Always use only the date part.
        const dateOnly = slot?.date ? slot.date.split("T")[0] : "";
        const isPreferred = formattedPreferredDates.includes(dateOnly);
        return {
            id: `${slot?.id}`,
            title: "Slot",
            start: `${dateOnly}${startTime}`,
            end: `${dateOnly}${endTime}`,
            feasibility_id: slot?.feasibility_id,
            type: slot?.status,
            hospital_name: slot?.hospital_name,
            patient_name: slot?.patient_name,
            phase_id: slot?.phase_id,
            phase_type: slot?.phase_type,
             is_reapheresis: slot?.is_reapheresis,
            reapheresis_reason: slot?.reason,
            cycle_no: slot?.cycle_no,
            subject_id: slot?.subject_id,
            request_date: slot?.request_date,
            slot_alignment_id: slot?.slot_alignment_id,
             change_requests:slot?.change_requests,
            cr_status: slot?.cr_status,
            change_request: slot?.change_request,
            has_open_change_request: slot?.has_open_change_request,
            is_open_request: slot?.is_open_request,
            is_cr: slot?.is_cr,
            is_cr_raised: slot?.is_cr_raised,
            cr_status_file: slot?.cr_status_file,
            cr_status_comment: slot?.cr_status_comment,
            clinical_feasibility_comment: slot?.clinical_feasibility_comment,
            clinical_status: slot?.clinical_status,
            financial_feasibility_comment: slot?.financial_feasibility_comment,
            financial_status: slot?.financial_status,
            payment_type: slot?.payment_type,
            updated_at: slot?.updated_at,
            product_name: slot?.product_name,
            phase_name: slot?.phase_name,
            clinical_by_name: slot?.clinical_by_name,
            financial_by_name: slot?.financial_by_name,
            slot_alignment_reason: slot?.slot_alignment_reason,
            media: slot?.media,
            clinical_media:slot?.clinical_media,
            financial_media:slot?.financial_media,
            eventType: isPreferred ? "preferred_date" : undefined,   // <-- ADDED
        };
    }) ?.sort((a, b) => {
     
      if (a.type?.toLowerCase() === 'request' && b.type?.toLowerCase() !== 'request') return -1;
      if (a.type?.toLowerCase() !== 'request' && b.type?.toLowerCase() === 'request') return 1;
      return 0; 
    });
}


export const convertPreferredDatesToEvents = (preferredDates) => {
    if (!preferredDates || !Array.isArray(preferredDates)) return [];

    const convertDMYtoYMD = (dateStr) => {
        const parts = dateStr.split("/");
        if (parts.length !== 3) return null;
        const [dd, mm, yyyy] = parts;
        return `${yyyy}-${mm}-${dd}`;
    };

    return preferredDates
        .map((dateItem) => {
            const startTime = "T10:00:00";
            const endTime = "T04:00:00";
            let dateString = null;
            if (typeof dateItem === "string") {
                // Convert DD/MM/YYYY → YYYY-MM-DD
                dateString = convertDMYtoYMD(dateItem);
            }
            if (!dateString) {
                console.warn("Invalid date format:", dateItem);
                return null;
            }
            return {
                title: "Slot",
                start: `${dateString}${startTime}`,
                end: `${dateString}${endTime}`,
                type: "Available",
                eventType: "preferred_date",
                originalDate: dateItem,
            };
        })
        .filter(Boolean);
};


export function sortDatesAsc(dateArray = []) {
  return [...dateArray].sort((a, b) => {
    // If any value is invalid → push it to the end safely
    if (typeof a !== "string" || typeof b !== "string") {
      return 0;
    }
    const toDate = (str) => {
      const parts = str.split("/");
      if (parts.length !== 3) return new Date(NaN);
      const [d, m, y] = parts.map(Number);
      return new Date(y, m - 1, d);
    };

    return toDate(a) - toDate(b);
  });
}